import type { ReactNode } from 'react';

interface Product {
  id: string;
  name: string;
  detail: string;
  image: string;
  colors: string[];
}

interface LandingProductCardProps {
  name: string;
  detail: string;
  image: string;
  colors: string[];
}

function LandingProductCard({ name, detail, image, colors }: LandingProductCardProps) {
  return (
    <article className="group cursor-pointer">
      <div className="bg-card-bg aspect-[3/4] mb-4 overflow-hidden">
        {image ? (
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-text-muted/50 text-xs tracking-widest uppercase">Photo</span>
          </div>
        )}
      </div>
      <div className="text-center">
        <h3 className="font-inter text-xs font-medium tracking-[0.15em] uppercase text-text-primary mb-2">
          {name}
        </h3>
        <p className="font-inter text-xs font-normal text-text-muted mb-2">{detail}</p>
        {colors.length > 0 && (
          <div className="flex justify-center items-center gap-2 mt-3">
            {colors.map((color, index) => (
              <button
                key={color}
                type="button"
                className="w-3 h-3 rounded-full border border-gray-300 hover:scale-110 transition-transform flex-shrink-0"
                style={{ backgroundColor: color }}
                aria-label={`Select color ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

function LandingProductRow({ children }: { children: ReactNode }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto w-full">{children}</div>
  );
}

export { LandingProductRow, LandingProductCard };
export type { Product, LandingProductCardProps };
